import React from 'react';
import styles from './ApproveButton.module.css';


export default function ApproveButton({ handleApprove }) {

    return (
      <div className={styles.buttonContainer}>
          <button type="submit" className={styles.approveButton} onClick={handleApprove}> APPROVE </button>
      </div>
    );

};
